import _get from 'lodash/get';

/**
 *
 * @desc Analytics
 *
 */

class Analytics {

    static pageName;

    static defaultMethod = (_event) => console.log('No tracking method found.', _event);

    static clearVarsDefaultMethod = () => console.log('No clearVars method found.');

    /**
     *
     * @desc Tracks an event.
     * @param {*} event - tracking object
     * refer to https://wiki.mlbam.com/pages/viewpage.action?spaceKey=omniture&title=Omniture+Variable+Mapping
     *
     */

    static track(event) {

        const trackAsync = _get(window, 'trackAsync', this.defaultMethod);
        trackAsync(event);

    }

    static trackPageView(event) {

        this.pageName = event.pageName;
        const trackPageView = _get(window, 'trackPageView', this.defaultMethod);
        const clearVars = _get(window, 'adobeAnalytics.clearVars', this.clearVarsDefaultMethod);
        clearVars();
        trackPageView(event);

    }

    static trackGoogleAnalytics(event) {

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event);

    }

    static triggerView(translationId) {

        window.targetPageParams = () => {

            return { 'entity.id': translationId };

        };
        const triggerView = _get(window, 'adobe.target.triggerView', this.defaultMethod);
        triggerView('videoStart');

    }

    static modifyTrackAsync() {

        const originalWindowTrackAsync = _get(window, 'trackAsync', this.defaultMethod);
        window.trackAsync = (props) => {

            originalWindowTrackAsync({
                pageName: this.pageName,
                prop13: this.pageName,
                ...props,
            });

        };

    }

};

export default Analytics;
